import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Map, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-4 pb-6 px-4 relative overflow-hidden" data-id="element-119">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-120">
        <div className="inline-block bg-brand-accent text-white font-bold px-3 py-1 rounded-full mb-2 text-xs md:text-sm tracking-wider shadow-md" data-id="element-121">
          🌾 KIT PROFE™
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black mb-2 leading-tight text-shadow-lg" data-id="element-122">
          Todo tu año de Economía Agropecuaria.
          <br data-id="element-123" />
          <span className="text-brand-accent neon-glow" data-id="element-124">Listo. Desde hoy.</span>
        </h1>

        <div className="w-full max-w-sm md:max-w-lg mx-auto mb-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToCompra} data-id="element-125">
          <img src="https://cdn.magicpatterns.com/uploads/ofvWm9YFk2yBFMgoiFvxmZ/mockups_economia_agropecuaria_(1).png" alt="Kit Completo Economía Agropecuaria Lista" className="w-full h-auto drop-shadow-2xl" data-id="element-126" />
        </div>

        <h2 className="text-base md:text-lg font-medium mb-1 max-w-2xl mx-auto text-brand-accent neon-glow" data-id="element-127">
          El sistema N°1 para docentes de escuelas técnicas agropecuarias y
          rurales en Argentina
        </h2>

        <p className="text-sm md:text-base mb-3 font-semibold text-gray-400" data-id="element-128">
          Tomos + evaluaciones + actividades listos para usar. Sin buscar. Sin
          armar. Sin perder domingos.
        </p>

        {/* 4 badges - 2x2 grid on mobile, 4 in a row on desktop */}
        <div className="grid grid-cols-2 md:flex md:items-center md:justify-center gap-2 md:gap-3 mb-3 w-full max-w-md md:max-w-none mx-auto" data-id="element-129">
          <div className="flex items-center justify-center bg-brand-accent/10 px-3 py-2 rounded-lg border border-brand-accent/30 text-xs md:text-sm font-semibold text-white" data-id="element-130">
            <FileText className="w-4 h-4 mr-2 text-brand-accent shrink-0" data-id="element-131" />
            <span data-id="element-132">📄 100% PDF</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-3 py-2 rounded-lg border border-brand-accent/30 text-xs md:text-sm font-semibold text-white" data-id="element-133">
            <Zap className="w-4 h-4 mr-2 text-brand-accent shrink-0" data-id="element-134" />
            <span data-id="element-135">⚡ 5 min</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-3 py-2 rounded-lg border border-brand-accent/30 text-xs md:text-sm font-semibold text-white" data-id="element-136">
            <Map className="w-4 h-4 mr-2 text-brand-accent shrink-0" data-id="element-137" />
            <span data-id="element-138">🌱 Adaptado al campo</span>
          </div>
          <div className="flex items-center justify-center bg-brand-accent/10 px-3 py-2 rounded-lg border border-brand-accent/30 text-xs md:text-sm font-semibold text-white" data-id="element-139">
            <BookOpen className="w-4 h-4 mr-2 text-brand-accent shrink-0" data-id="element-140" />
            <span data-id="element-141">🇦🇷 Secundaria técnica</span>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto mb-2" data-id="element-142">
          <Button className="text-lg md:text-2xl py-3 md:py-4" data-id="element-143">
            👉 QUIERO MI KIT AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-500" data-id="element-144">
          <div className="flex items-center" data-id="element-145">
            <ShieldCheck className="w-4 h-4 mr-1 text-brand-accent" data-id="element-146" />
            <span data-id="element-147">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-148">
            <Lock className="w-4 h-4 mr-1 text-brand-accent" data-id="element-149" />
            <span data-id="element-150">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-151">
            <CreditCard className="w-4 h-4 mr-1 text-brand-accent" data-id="element-152" />
            <span data-id="element-153">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}